export default __webpack_public_path__ + "static/media/speaker.a2af0449.svg";